// api should be here
import { http } from '@/utils/http';
import qs from 'qs';
// 活动api baseurl
const urlPrefix = 'vote/2023project/q3/2023yxqy/controller.php?enews=';

const getBaseInfo = () => {
  return http.get(`${urlPrefix}base-info`);
};

const getVoteList = (page: number) => {
  return http.get(`${urlPrefix}vote-list`, {
    params: {
      page,
    },
  });
};

const getDetail = (id: string) => {
  return http.get(`${urlPrefix}detail`, {
    params: {
      id,
    },
  });
};

const getNews = (page: any, category: any, classId: any) => {
  return http.get(
    `/v1/news/topicList?page=${page}&classId=${classId}&category=${category}`,
  );
};

export const getRules = (id: number) => {
  const data: { [key: number]: string } = {
    1: `<p>习近平总书记高度重视中小企业发展，对促进中小企业发展作出系列重要指示批示，强调坚持“两个毫不动摇”“中小企业能办大事”，要激发涌现一大批“专精特新”中小企业。在市委、市政府坚强领导下，重庆成为“专精特新”强市。目前，全市市级“专精特新”中小企业3850家，“小巨人”企业288家。随着“专精特新“培育工作的深入推进，涌现出一大批优质中小企业和优秀企业家，在我市产业发展的专业化、创新能力、补链强链等方面发挥了重要作用。为进一步带动中小企业创新发展，大力弘扬企业家精神，深度发挥标杆榜样作用，在去年基础上，特启动2023年评选活动。</p>`,
    2: `<h4 style='text-indent:2em;'>一、指导单位</h4>
      <p>重庆市经济和信息化委员会</p>
      <h4 style='text-indent:2em;'>二、主办单位</h4>
      <p>重庆日报报业集团</p>
      <h4 style='text-indent:2em;'>三、承办单位</h4>
      <p>上游新闻、重庆市中小企业发展服务中心、重庆市企业家联合会</p>
      <h4 style='text-indent:2em;'>四、支持媒体</h4>
      <p>重庆日报、华龙网、中国经济时报</p>
      `,
    3: `<p><span style='font-weight:600'>2023专精特新中小企业优秀企业家（30名）</span></p>`,
    4: `<h4 style='text-indent:2em;'>一、评选范围</h4>
        <p style='text-indent:2em;'>截至本活动正式启动网络报名前公布的重庆市级“专精特新”中小企业，国家专精特新“小巨人”企业（不包含已获评“2022年度重庆市专精特新优秀企业家”的企业）。</p>
          <p>1. 坚持正确政治方向，热爱祖国，自觉践行社会主义核心价值观。遵守宪法和法律。</p>
          <p>2. 具有良好的职业操守，诚信经营，关爱职工，奉献社会、敢为人先、善于管理、为人正派，在业界具有良好声誉，无违法违规行为。</p>
          <p>3. 参评对象为重庆市市级专精特新中小企业或国家专精特新“小巨人”企业法定代表人、公司董事长、执行董事或总经理，在参评企业从业5年及以上。</p>
          <p>4. 参评对象所带领企业近两年营业收入须为正增长，企业创新性较强，成长性较好，主导产品在细分市场中具备较强竞争力，企业纳税、吸纳就业等情况表现良好，为行业及区域经济发展所做贡献较好。</p>
          <p>5. 积极主动履行社会责任，参与社会公益，兼任社会职务认真积极履职。</p>
          
          <h4 style='text-indent:2em;'>二、评选方式</h4>
          <p>1.评选分为组委会初选、网络展示、专家评审和结果公示等环节。</p>
          <p>2.优秀企业家名单将在上游新闻客户端面向社会进行为期7天的公示。
          </p>
    `,
    5: `<h4 style='text-indent:2em;'>一、启动征集：8月26日—9月29日</h4>
    <p>包含：报名启动信息发布、报名宣传、渠道对接、重点企业报名指导、报名材料整理、企业案例报道。</p>
    <h4 style='text-indent:2em;'>二、初步筛选：10月7日—10月25日</h4>
    <p>包含：报名资料统计、报名资料筛选、确定评审名单。</p>
    <h4 style='text-indent:2em;'>三、专家评审：10月26日—11月5日</h4>
    <p>包含：确定邀请评审、组织召开评审会、评出30位优秀企业家名单。</p>
    <h4 style='text-indent:2em;'>四、官网公示：11月6日—11月13日</h4>
    <p>包含：各渠道公示，组委会针对公示企业家逐一进行复核。</p>
    <h4 style='text-indent:2em;'>五、网络展示：11月14日—11月30日</h4>
    <p>包含：优秀企业家集中宣传。</p>
    <h4 style='text-indent:2em;'>六、颁奖典礼：11月中下旬</h4>
    <p>包含：颁奖典礼筹备、组织实施。</p>
    <p>备注：具体执行时间以组委会通知为准。
    </p>
    `,
    6: `<h4 style='text-indent:2em;'>一、报名方式</h4></p>
    <p>（一）评选活动由各区县中小企业主管部门、有关行业协（学）会推荐符合条件的企业家参评，每家企业只能推荐1人。</p>
    <p>（二）参评企业家须填写附件2和附件3提交至推荐方（各区县中小企业主管部门、有关行业协（学）会），由推荐方在附件2表格对应栏内提出推荐意见并加盖印章。推荐方汇总企业家报名资料后填写汇总表（附件1），在2023年9月29日18:00前，扫描推荐的企业家报名表（含附件2、3）并附汇总表（附件1），将上述电子版发至指定邮箱（需提交1份电子文档版，1份盖章扫描版，邮件主题标注为“推荐单位”，推荐多家企业的，请一次性发送）。</p>
    <p>（三）组委会联系方式</p>
    <p>1. E-MAIL：cqzjtx2023@163.com</p>
    <p>邮件请标明：“申报项目+企业全名” 。</p>
    <p>2. 联系人及联系方式：</p>
    <p>吴老师18623564404  刘老师18523166639</p>
    
    <h4 style='text-indent:2em;'>二、报名表下载</h4>
    <p><a href="https://image2.cqcb.com/vote/2023yxqypx/2023youxiuqiyejiahuizong.docx" download="2023重庆市专精特新优秀企业家汇总表.docx">
    附件1：2023重庆市专精特新优秀企业家汇总表
    </a></p>
    <p><a href="https://image2.cqcb.com/vote/2023yxqypx/2023youxiuqiyejiashenbao1.docx" download="2023专精特新中小企业优秀企业家申报表1.docx">
    附件2：2023专精特新中小企业优秀企业家申报表1
    </a></p>
    <p><a href="https://image2.cqcb.com/vote/2023yxqypx/2023youxiuqiyejiashenbao2.docx" download="2023专精特新中小企业优秀企业家申报表2.docx">
    附件3：2023专精特新中小企业优秀企业家申报表2
    </a></p>
    `,
  };
  return data[id];
};
export { getBaseInfo, getVoteList, getDetail, getNews };
